import { Button } from '@progress/kendo-react-buttons';
import { Field, Form, FormElement } from '@progress/kendo-react-form';
import Body from 'commons/card/Body';
import { default as Card } from 'commons/card/CollapsableCard';
import Header from 'commons/card/Header';
import LoadingCard from 'commons/card/LoadingCard';
import { FormCheckbox, FormDropDownList, FormInput } from 'commons/forms/form';
import EmptyResult from 'commons/status/EmptyResult';
import * as r from 'constants/routes';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { SidePane } from 'react-side-pane';
import { InventoryContext } from '../providers/InventoryProvider';
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

export default function Solr() {
  const mappedFilters = {
    div_concat_s: { name: 'Division', type: 'dropdown' },
    dept_concat_s: { name: 'Département', type: 'dropdown' },
    cat_concat_s: { name: 'Catégorie', type: 'dropdown' },
    act_concat_s: { name: 'Activité', type: 'dropdown' },
    four_concat_s: { name: 'Fournisseur', type: 'dropdown' },
    mod_concat_s: { name: 'Modèle', type: 'dropdown' },
    fini_concat_s: { name: 'Fini', type: 'dropdown' },
    prod_groupe_txt_fr: { name: 'Collection', type: 'dropdown' },
    prix_f: { name: 'Prix', type: 'range' },
    qte_imm_i: { name: 'Quantité immédiate', type: 'greater' },
    endommage_b: { name: 'Produits endommagé', type: 'checkbox' },
    recherche: { name: 'Recherche', type: 'search' },
  };
  const [data, setData] = useState(undefined);
  const [found, setFound] = useState(0);
  const [facets, setFacets] = useState(undefined);
  const [isLoaded, setLoaded] = useState(true);
  const [isOpenSide, setOpenSide] = useState(false);
  const [error, setError] = useState(false);
  const { setLastQueryJSON, query, clicked, setLastClickedJSON } =
    useContext(InventoryContext);
  const [fitlers, setFilters] = useState(query);
  const ref = useRef(undefined);
  const refFilters = useRef(undefined);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    handleSubmit(query);
  }, []);

  const handleSubmit = (addedFilters) => {
    if (query.recherche !== fitlers.recherche || addedFilters.recherche === '') {
      addedFilters = {
        recherche: addedFilters.recherche,
        qte_imm_i: true,
        from: 1,
        to: 99999,
      };
      setFilters(addedFilters);
    }
    const all = addedFilters;

    var queries = `&q=${all.recherche} -and -or (mod_descr_txt_fr:${all.recherche}) and (four_nom_txt_fr:${all.recherche}) and (prod_num_txt_fr:${all.recherche.length === 7 && all.recherche?.charAt(0) === '0' ? all.recherche.slice(1) : all.recherche})&fq=prix_f:[${all.from} TO ${all.to}]`;

    Object.keys(all)
      .filter((e) => mappedFilters[e]?.type === 'dropdown')
      .forEach((e) => (queries += `&fq=${e}:"${all[e].split(':')[0]}"`));

    Object.keys(all)
      .filter((e) => mappedFilters[e]?.type === 'greater')
      .forEach(
        (e) =>
          (queries += `&fq=${e}:${all[e] ? '[1 TO 999998]' : '[0 TO 999998]'}`)
      );

    Object.keys(all)
      .filter((e) => mappedFilters[e]?.type === 'checkbox')
      .forEach((e) => (queries += all[e] ? `&fq=${e}:${all[e]}` : ''));

    setLastQueryJSON(all);
    setData(undefined);
    setFound(0);
    setError(false);
    setLoaded(false);
    fetch(r.SOLR, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ var: encodeURI(queries).toString() }),
    })
      .then((e) => e.json())
      .then((x) => {
        setLoaded(true);
        if (x) {
          setData(x.response.docs);
          setFound(x.response.numFound);
          setFacets(x.facet_counts);
          setTimeout(() => {
            if (document.getElementById(clicked))
              document.getElementById(clicked).scrollIntoView();
            setLastClickedJSON('');
          }, 800);
        }
      })
      .catch((e) => setError(true));
  };

  const Info = ({ text, onClick = () => { }, style = {} }) => {
    return (
      <p onClick={onClick} style={{ marginBottom: 0, ...style }}>
        {text}
      </p>
    );
  };

  const onNavigate = (e) => {
    setLastClickedJSON(e);
    navigate(location.pathname + '/Produit=' + e);
  };

  const toggleSidePanel = () => {
    setOpenSide(!isOpenSide);
  };

  return (
    <>
      <Card style={{ backgroundColor: 'white' }}>
        <Header title={`Inventaire`}></Header>
        <Body>
          <Form
            ref={ref}
            initialValues={fitlers}
            onSubmit={() => handleSubmit(fitlers)}
            ignoreModified={true}
            render={() => (
              <FormElement>
                <fieldset className={'k-form-fieldset'}>
                  <div className="row">
                    <div className="col-md-6">
                      <Field
                        id={'recherche'}
                        name={'recherche'}
                        label={'Recherche'}
                        onChange={(e) =>
                          setFilters({ ...fitlers, recherche: e.value })
                        }
                        component={FormInput}
                      />
                    </div>
                  </div>
                </fieldset>
                <div className="k-form-buttons">
                  <Button type={'submit'} className="blueButton">
                    Rechercher
                  </Button>
                </div>
              </FormElement>
            )}
          />
        </Body>
      </Card>
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <Info
          style={{
            color: 'rgb(165, 165, 165)',
            marginLeft: '1rem',
          }}
          text={`${found} produit(s) trouvé(s)`}
        />
        <Info
          style={{
            color: '#147bfc',
            marginRight: '1rem',
            cursor: 'pointer',
          }}
          text="Filtres"
          onClick={toggleSidePanel}
        />
      </div>

      <ul style={{ listStyle: 'none', padding: '1rem' }}>
        {data &&
          data.map((e, i) => (
            <li
              id={e.prod_num}
              onClick={() => onNavigate(e.prod_num)}
              className="list-solr"
              style={{ padding: '0.5rem 0rem' }}
              key={i}
            >
              <div
                style={{
                  display: 'flex',
                  padding: '0.5rem',
                  boxShadow: '0px 0px 5px rgb(0 0 0 / 20%)',
                }}
              >
                <img
                  onError={(e) =>
                  (e.currentTarget.src =
                    'https://cdn.tanguay.ca/images/products/320px/empty_photo.jpg')
                  }
                  width="175px"
                  alt="img"
                  src={`https://cdn.tanguay.ca/images/products/320px/${e.img_s}`}
                />
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    marginLeft: '2rem',
                  }}
                >
                  <h1>
                    {e.mod_descr_txt_fr} ({e.prod_num})
                  </h1>
                  <Info style={{ fontSize: '14px' }} text={e.four_concat_s} />
                  <Info
                    style={{ fontSize: '14px' }}
                    text={`${e.mod_cd_txt_fr} - ${e.mod_descr_txt_fr}`}
                  />
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                    }}
                  >
                    <Info text={`Quantité immédiate: ${e.qte_imm_i}`} />
                    {e.qte_endo_i > 0 && (
                      <Info text={`Quantité endommagée: ${e.qte_endo_i}`} />
                    )}
                  </div>
                  <Info
                    style={{
                      fontSize: '20px',
                      color: '#147bfc',
                      fontWeight: 'bold',
                    }}
                    text={`${e.prix_tot_f} $`}
                  />
                  <Info
                    style={{ fontSize: '14px' }}
                    text={`${e.prix_f} $ + ÉCOFRAIS ${e.ecofrais_f} $`}
                  />
                  <Info
                    style={{ fontSize: '14px' }}
                    text={`${e.div_nom_txt_fr} | ${e.dept_nom_txt_fr} | ${e.cat_descr_txt_fr} `}
                  />
                </div>
              </div>
            </li>
          ))}
      </ul>
      {!isLoaded && !error ? <LoadingCard title="Recherche..." /> : null}
      {isLoaded && error ? (
        <EmptyResult
          title={'Aucun produit trouvé'}
          message={'veuillez affiner votre recherche'}
        />
      ) : null}
      {isLoaded && !error && data?.data?.length === 0 && (
        <EmptyResult
          title={'Aucun produit trouvé'}
          message={'veuillez affiner votre recherche'}
        />
      )}
      <SidePane width={20} open={isOpenSide} onClose={toggleSidePanel} style={{ top: '50px' }}>
        <Form
          ref={refFilters}
          initialValues={fitlers}
          onSubmit={handleSubmit}
          render={() => (
            <FormElement>
              <fieldset className={'k-form-fieldset'}>
                <div className="row" style={{ margin: 0 }}>
                  <div className="col-md-12">
                    {facets?.facet_fields && (
                      <>
                        {Object.keys(facets.facet_fields).map((e) => {
                          switch (mappedFilters[e]?.type) {
                            case 'range':
                              return (
                                <div className="row" style={{ margin: 0 }}>
                                  <div className="col-md-6">
                                    <Field
                                      id={'from'}
                                      name={'from'}
                                      label={'Prix début'}
                                      onChange={(e) => {
                                        setFilters({
                                          ...fitlers,
                                          from: e.value,
                                        });
                                        handleSubmit({
                                          ...fitlers,
                                          from: e.value,
                                        });
                                      }}
                                      component={FormInput}
                                    />
                                  </div>
                                  <div className="col-md-6">
                                    <Field
                                      id={'to'}
                                      name={'to'}
                                      label={'Prix fin'}
                                      onChange={(e) => {
                                        setFilters({
                                          ...fitlers,
                                          to: e.value,
                                        });
                                        handleSubmit({
                                          ...fitlers,
                                          to: e.value,
                                        });
                                      }}
                                      component={FormInput}
                                    />
                                  </div>
                                </div>
                              );
                            case 'greater':
                            case 'checkbox':
                              return (
                                <Field
                                  id={e}
                                  name={e}
                                  label={mappedFilters[e].name}
                                  component={FormCheckbox}
                                  onChange={(g) => {
                                    setFilters({
                                      ...fitlers,
                                      [e]: g.value,
                                    });
                                    handleSubmit({
                                      ...fitlers,
                                      [e]: g.value,
                                    });
                                  }}
                                />
                              );
                            default:
                              return (
                                <Field
                                  onChange={(g) => {
                                    setFilters({
                                      ...fitlers,
                                      [e]: g.value,
                                    });
                                    handleSubmit({
                                      ...fitlers,
                                      [e]: g.value,
                                    });
                                  }}
                                  id={e}
                                  name={e}
                                  label={mappedFilters[e].name}
                                  component={FormDropDownList}
                                  data={facets.facet_fields[e]
                                    .map((b, i) => {
                                      return i % 2
                                        ? `${facets.facet_fields[e][i - 1]}: ${facets.facet_fields[e][i]
                                        }`
                                        : undefined;
                                    })
                                    .filter((e) => e !== undefined)
                                    .filter((e) => e.split(':')[1] > 0)}
                                />
                              );
                          }
                        })}
                      </>
                    )}
                  </div>
                </div>
              </fieldset>
              <div className="k-form-buttons">
                <Button
                  onClick={() => {
                    ref.current.onReset();
                    const resetData = {
                      recherche: '',
                      qte_imm_i: true,
                      from: 1,
                      to: 99999,
                    };
                    setFilters(resetData);
                    handleSubmit(resetData);
                    setFacets(undefined);
                    setTimeout(() => {
                      toggleSidePanel();
                      ref.current.onReset();
                      setFilters(resetData);
                    }, 100);
                  }}
                  className="whiteButton"
                  style={{
                    width: '100px',
                    height: '36px',
                    marginLeft: '1rem',
                  }}
                >
                  Réinitialiser
                </Button>
              </div>
            </FormElement>
          )}
        />
      </SidePane>
    </>
  );
}
